var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.33295 16.048 12.23845-12.23848c.9994-.99937 2.6197-.99937 3.6191 0 .9993.99938.9993 2.61968 0 3.61905l-12.2385 12.23843c-.2792.2792-.6348.4696-1.02198.547l-3.93002.786.786-3.93c.07744-.3872.26775-.7428.54695-1.022z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5 16.5 3 3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 6.5 3 3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.5d4fde8ba4bf9b0c63b5d52b9c5ce05e.svg";
export { ForwardRef as ReactComponent };